"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = void 0;
const is_empty_1 = require("utils/is-empty");
const password_validator_1 = require("utils/password-validator");
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    let validate = {
        isError: false,
        data: initialErrorStatus
    };
    try {
        // Password validation logic
        if (arg.isAdd) {
            // For add mode: password is required
            if ((0, is_empty_1.isEmpty)(arg.password)) {
                validate = {
                    isError: true,
                    data: Object.assign(Object.assign({}, validate.data), { password: { status: true, message: 'Required' } })
                };
            }
            else if (arg.password) {
                // Validate password strength
                const passwordValidation = (0, password_validator_1.validatePassword)(arg.password);
                if (!passwordValidation.isValid) {
                    validate = {
                        isError: true,
                        data: Object.assign(Object.assign({}, validate.data), { password: { status: true, message: passwordValidation.errors[0] } })
                    };
                }
            }
            // Validate confirm password for add mode
            if (arg.password !== arg.confirmPassword) {
                validate = {
                    isError: true,
                    data: Object.assign(Object.assign({}, validate.data), { confirmPassword: { status: true, message: 'Password not match' } })
                };
            }
        }
        else if (!arg.isAdd && arg.password) {
            // For edit mode: password is optional, but if provided, must be valid
            const passwordValidation = (0, password_validator_1.validatePassword)(arg.password);
            if (!passwordValidation.isValid) {
                validate = {
                    isError: true,
                    data: Object.assign(Object.assign({}, validate.data), { password: { status: true, message: passwordValidation.errors[0] } })
                };
            }
            // Validate confirm password only if password is provided
            if (arg.password !== arg.confirmPassword) {
                validate = {
                    isError: true,
                    data: Object.assign(Object.assign({}, validate.data), { confirmPassword: { status: true, message: 'Password not match' } })
                };
            }
        }
        if ((0, is_empty_1.isEmpty)(arg.contractor)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { contractor: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.role)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { role: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.is_active)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { is_active: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.username)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { username: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.fullname)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { fullname: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: initialErrorStatus
        };
    }
});
exports._validator = _validator;
const initialErrorStatus = {
    contractor: { status: false, message: 'Required' },
    department: { status: false, message: 'Required' },
    is_active: { status: false, message: 'Required' },
    fullname: { status: false, message: 'Required' },
    operator_access: { status: false, message: 'Required' },
    username: { status: false, message: 'Required' },
    role: { status: false, message: 'Required' },
    password: { status: false, message: 'Required' },
    confirmPassword: { status: false, message: 'Required' },
};
